// extracted by mini-css-extract-plugin
export default {"cautionDescription":"styles_cautionDescription__cs+zZ"};